module.exports = __webpack_public_path__ + "static/media/MightyBuildings-Dark.3cb8eaf7.webp";